import React, { useEffect, useState } from "react";
import { get } from "../../config/axios";
import Layout from "../../layout/Main/Layout";
import {
  Typography,
  Card,
  CardContent,
  Grid,
  TextField,
  Button,
} from "@mui/material";
import CustomTable from "../../components/Custom/Table/CustomTable";
import { transactionTableColumn } from "../../constants/transactionPage";
import moment from "moment";
import { toastMessage } from "../../utils/toastMessage";

const ReportAndAnalytics = () => {
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [loading, setLoading] = useState(true);
  const [analyticsData, setAnalyticsData] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [activeUsers, setActiveUsers] = useState(0);
  const [inactiveUsers, setInactiveUsers] = useState(0);
  const [startDate, setStartDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

  const fetchTransaction = async () => {
    try {
      if (new Date(startDate) > new Date(endDate)) {
      setAnalyticsData([]);
        toastMessage("Start date cannot be greater than end date.", "error");
        return;
      }
      setLoading(true);
      const res = await get(
        `/api/dashboard/dashUser/user-analytics?startDate=${startDate}&endDate=${endDate}`
      );
      setAnalyticsData(res?.data);
      setLoading(false);
      setPageCount(res?.totalPages);
      setTotalUsers(res?.totalUsers);
      setActiveUsers(res?.activeUsers);
      setInactiveUsers(res?.inactiveUsers);
    } catch (err) {
      console.log("Error", err);
      setLoading(false);
    }
  };

  //   useEffect(() => {
  //     fetchTransaction();
  //   }, [startDate, endDate]);

  const handleApplyFilters = () => {
    fetchTransaction();
  };
  return (
    <Layout>
      <div style={{ padding: "1rem" }}>
        <Typography variant="h5" style={{ marginBottom: "1rem" }}>
          User Report and Analytics
        </Typography>

        <Grid container spacing={2} style={{ marginBottom: "1rem" }}>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              type="date"
              label="Start Date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              type="date"
              label="End Date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={2}
            style={{ display: "flex", alignItems: "center" }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleApplyFilters}
            >
              Apply Filters
            </Button>
          </Grid>
        </Grid>

        <Grid container spacing={2} style={{ marginBottom: "1rem" }}>
          <Grid item xs={12} sm={4}>
            <Card>
              <CardContent>
                <Typography variant="h6">New Registration</Typography>
                <Typography variant="h4">
                  {analyticsData?.newRegistrations || 0}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Card>
              <CardContent>
                <Typography variant="h6">Active Users</Typography>
                <Typography variant="h4">
                  {analyticsData?.activeUsers || 0}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Card>
              <CardContent>
                <Typography variant="h6">Retention Rate</Typography>
                <Typography variant="h4">
                  {analyticsData?.retentionRate === "NaN" ||
                  analyticsData?.retentionRate === "Infinity"
                    ? 0
                    : analyticsData?.retentionRate || 0}
                  %
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Card>
              <CardContent>
                <Typography variant="h6">Average Session Duration</Typography>
                <Typography variant="h4">
                  {analyticsData?.averageSessionDuration || 0} MIN
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        {/* <CustomTable
          data={transactionData}
          columns={transactionTableColumn}
          handleEdit={() => {}}
          handleDelete={() => {}}
          handleStatus={() => {}}
          handleActive={() => {}}
          handlePageChange={(page) => handleChange(page)}
          pageNumber={page}
          pageCount={pageCount}
          loading={loading}
        /> */}
      </div>
    </Layout>
  );
};

export default ReportAndAnalytics;
